"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _guids = require("reporting-data/lib/guids");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _omit = _interopRequireDefault(require("transmute/omit"));

var _PropertyRecord = _interopRequireDefault(require("customer-data-objects/property/PropertyRecord"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIHelpIcon = _interopRequireDefault(require("UIComponents/icon/UIHelpIcon"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var getTransferableProps = (0, _omit.default)(['actions', 'baseUrl', 'isInline', 'isExpandableTextInputEnabled', 'getProperty', 'InputComponent', 'objectType', 'onCancel', 'onInvalidProperty', 'onSecondaryChange', 'options', 'propertyIndex', 'readOnlySourceData', 'resize', 'resolver', 'secondaryChanges', 'showError', 'subject', 'subjectId', 'wrappers', 'propertyInputComponentConfig', 'onTracking', 'isRequired']);
var propTypes = {
  autoFocus: _react.PropTypes.bool,
  displayValue: _react.PropTypes.string,
  property: _react.PropTypes.instanceOf(_PropertyRecord.default).isRequired,
  value: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])
};

var PropertyInputReadOnly =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(PropertyInputReadOnly, _Component);

  function PropertyInputReadOnly() {
    (0, _classCallCheck2.default)(this, PropertyInputReadOnly);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PropertyInputReadOnly).apply(this, arguments));
  }

  (0, _createClass2.default)(PropertyInputReadOnly, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoFocus) {
        this.focus();
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      var input = this.refs.input;

      if (input && input.focus) {
        this.refs.input.focus();
      }
    }
  }, {
    key: "getDisplayValue",
    value: function getDisplayValue() {
      var value = this.props.value;

      if (!value) {
        return value;
      }

      if ((0, _guids.isKnownGuid)(value)) {
        return (0, _guids.getGuidLabel)(value);
      }

      return value;
    }
  }, {
    key: "renderInternalValueTooltipIcon",
    value: function renderInternalValueTooltipIcon() {
      var value = this.props.value;

      if (!value || !(0, _guids.isKnownGuid)(value)) {
        return null;
      }

      var tooltipMessage = _react.default.createElement(_FormattedMessage.default, {
        message: "recordProperties.original_value",
        options: {
          originalValue: value
        }
      });

      return _react.default.createElement(_UIHelpIcon.default, {
        title: tooltipMessage,
        tooltipPlacement: "top right",
        className: "p-top-1 p-right-2"
      });
    }
  }, {
    key: "renderTextInput",
    value: function renderTextInput() {
      return _react.default.createElement(_UITextInput.default, (0, _extends2.default)({}, getTransferableProps(this.props), {
        readOnly: true,
        ref: "input",
        value: this.getDisplayValue()
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_UIFlex.default, {
        align: "center"
      }, this.renderInternalValueTooltipIcon(), this.renderTextInput());
    }
  }]);
  return PropertyInputReadOnly;
}(_react.Component);

exports.default = PropertyInputReadOnly;
PropertyInputReadOnly.propTypes = propTypes;
module.exports = exports.default;